<template>
    <ClicColInterno
        alignSelf="end"
        :cp="cp"
        :key="componentKey"
    >
        <ClicSwaggerInterno
            ref="swaggerInterno"
            :cp="cp"
            :state="state"
            :url="url"
            :spec="spec"
        />
    </ClicColInterno>
</template>

<script>
import ComponentMixin from '../../core/ComponentMixin';

export default {
    name: "ClicSwagger",
    components: {
        ClicSwaggerInterno: () => import(
            /* webpackChunkName: "ClicSwaggerInterno", webpackPrefetch: false */ './ClicSwaggerInterno.vue'
        ),
    },
    mixins: [ComponentMixin],

    mounted() {
    },

    data() {
        return {
            spec : undefined,
            url : undefined
        };
    },
    
    watch: {
        url(url) {
            this.dataRefresh();
        },
        spec(spec) {
            this.dataRefresh();
        },
    },

    methods: {

        dataRefresh () {
            this.$refs.swaggerInterno?.dataRefresh();
        }
    }
}
</script>

<style>
    .swagger-ui {
        background :#fafafa;
    }
    .topbar {
        background: #ffffff !important;
    }
    
    /*
    .topbar-wrapper img {
        content : url('https://cdnfw.nyc3.digitaloceanspaces.com/framework/admfw/imagens/identidade/logo.png') !important;
    }*/

    .download-url-wrapper {
        display: none !important;
    }

    .swagger-ui table thead tr th {
        background-color: transparent;
    }

    .version-stamp {
        visibility: hidden;
    }
</style>
